import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {ApplicationSettings} from '../../models/application-settings.model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationSettingsService {
  constructor(private readonly http: HttpClient) {
  }

  fetchApplicationSettingsByDataCode(dataCode: string): Observable<ApplicationSettings> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get<ApplicationSettings>(`api/application-setting?dataCode=${encodeURIComponent(dataCode)}`, { headers });
  }
}
